// extracted by mini-css-extract-plugin
module.exports = {"svg":"Preloader_svg__7Bi4l","spinner-rotate":"Preloader_spinner-rotate__Vl_qf","circle":"Preloader_circle__66t9j","spinner-offset":"Preloader_spinner-offset__kbpwN"};